/* eslint no-shadow: "off", no-param-reassign: ["error", { "props": false }], no-console: "off", quotes: "off" */

import axios from 'axios';
import auth from '../../../common/auth';

export default {
  fetchUserConversations({ commit }) {
    return axios({
      url: 'api/chat/getConversations',
      method: 'GET',
      headers: {
        Authorization: auth.getJwt(),
      },
    }).then((response) => {
      const conversationList = response.data.data;
      commit('setUserConversations', conversationList);
      commit('users/setSearchedUsers', conversationList.flatMap(c => c.members), { root: true });
    }).catch((error) => {
      console.log(`Something went wrong while getting user's conversations: ${error}`);
    });
  },
  createConversation({ commit }, username) {
    return axios({
      url: `api/chat/addConversation/${username}`,
      method: 'GET',
      headers: {
        Authorization: auth.getJwt(),
      },
    }).then((response) => {
      const newConversation = response.data.data;
      commit('setActiveConversation', newConversation);
    }).catch((error) => {
      console.log(`Something went wrong while open/create conversation: ${error}`);
    });
  },
  // eslint-disable-next-line
  fetchConversationMessages({ commit }, { conversationId, fetched }) {
    return axios({
      url: `api/chat/getMessages/${conversationId}?fetchedNumber=${fetched}`,
      method: 'GET',
      headers: {
        Authorization: auth.getJwt(),
      },
    }).catch((error) => {
      console.log(`Something went wrong while getting conversation's messages: ${error}`);
    });
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/chat/actions.js